import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../assets/img/icons/add-circle.svg'
import _imports_1 from '../../assets/img/icons/eye.svg'
import _imports_2 from '../../assets/img/icons/edit.svg'
import _imports_3 from '../../assets/img/icons/close.svg'


const _hoisted_1 = { class: "main-content bg_gray d-flex flex-column transition overflow-hidden" }
const _hoisted_2 = { class: "card border-0 shadow-none rounded-1 mb-25" }
const _hoisted_3 = { class: "card-body p-xl-40" }
const _hoisted_4 = { class: "product-toolbar mb-4" }
const _hoisted_5 = { class: "product-toolbar__filters" }
const _hoisted_6 = { class: "product-toolbar__filter product-toolbar__filter--search" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "product-toolbar__filter" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { value: 0 }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "product-toolbar__filter" }
const _hoisted_13 = { value: 0 }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "product-toolbar__filter" }
const _hoisted_16 = { value: 0 }
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "product-toolbar__filter" }
const _hoisted_19 = { value: 0 }
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "product-toolbar__filter" }
const _hoisted_22 = { value: 0 }
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "product-toolbar__actions" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = ["alt"]
const _hoisted_27 = { class: "product-table-shell" }
const _hoisted_28 = ["src", "alt"]
const _hoisted_29 = ["checked", "onChange"]
const _hoisted_30 = { class: "table-emenu-toggle__label" }
const _hoisted_31 = {
  key: 9,
  class: "d-flex justify-content-center gap-2"
}
const _hoisted_32 = ["alt"]
const _hoisted_33 = ["alt"]
const _hoisted_34 = ["title", "onClick"]
const _hoisted_35 = ["alt"]

import { onMounted, computed, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useProduct } from "../../composables/useProduct";
import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import BreadcrumbMenu from "../../components/Common/BreadcrumbMenu.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductsListPage',
  setup(__props) {

const { t } = useI18n();

const {
  filteredProducts,
  loading,
  importInput,
  searchQuery,
  selectedCategoryId,
  selectedBrandId,
  selectedUnitId,
  selectedSizeId,
  selectedWarehouseId,
  warehouseLockedToProfile,
  categories,
  brands,
  units,
  sizes,
  warehouses,
  selectedIds,
  paginationConfig,
  stateStore,
  fetchProducts,
  fetchFiltersData,
  initializeWarehouseContext,
  deleteProduct,
  toggleEmenuVisibility,
  getImageUrl,
  getDisplayQty,
  getSizeLabel,
  exportExcel,
  triggerImport,
  handleImportChange,
  handleTableChange,
} = useProduct();

onMounted(async () => {
  await initializeWarehouseContext();
  await Promise.all([fetchProducts(), fetchFiltersData()]);
});

// Row Selection Logic for Ant Design Table
const selectedRowKeys = computed({
  get: () => selectedIds.value,
  set: (val) => { selectedIds.value = val; }
});

const rowSelection = {
  selectedRowKeys: selectedRowKeys,
  onChange: (newSelectedRowKeys: (string | number)[]) => {
    selectedRowKeys.value = newSelectedRowKeys as number[];
  },
};

const handleEmenuToggle = (record: any, event: Event) => {
  const target = event.target as HTMLInputElement;
  toggleEmenuVisibility(record, target.checked);
};

// Sync underlying selection logic
watch(selectedRowKeys, (newVal) => {
  selectedIds.value = newVal;
});

const tableLocale = computed(() => ({
  emptyText: t("product_page.no_products_found"),
}));

const columns = computed(() => [
  { title: t("product_page.image"), dataIndex: "image", key: "image", align: "center" },
  { title: t("product_page.code"), dataIndex: "code", key: "code", align: "center", sorter: (a: any, b: any) => a.code.localeCompare(b.code) },
  { title: t("product_page.product_name"), dataIndex: "name", key: "name", align: "center", sorter: (a: any, b: any) => a.name.localeCompare(b.name) },
  { title: t("product_page.category"), dataIndex: "category", key: "category", align: "center" },
  { title: t("product_page.brand"), dataIndex: "brand", key: "brand", align: "center" },
  { title: t("product_page.price"), dataIndex: "price", key: "price", align: "center", sorter: (a: any, b: any) => Number(a.price) - Number(b.price) },
  { title: t("product_page.unit"), dataIndex: "unit", key: "unit", align: "center" },
  { title: t("product_page.size"), dataIndex: "size", key: "size", align: "center" },
  { title: t("product_page.type"), dataIndex: "type", key: "type", align: "center" },
  { title: t("product_page.stock"), key: "stock", align: "center", sorter: (a: any, b: any) => Number(getDisplayQty(a)) - Number(getDisplayQty(b)) },
  { title: t("product_page.public_emenu"), key: "emenu", align: "center" },
  { title: t("product_page.action"), key: "actions", align: "center" },
]);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(MainHeader),
    _createVNode(MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(BreadcrumbMenu, { pageTitle: "product_list" }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control product-toolbar__control",
                  placeholder: _unref(t)('product_page.search_by_name_or_code'),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchQuery) ? (searchQuery).value = $event : null))
                }, null, 8, _hoisted_7), [
                  [_vModelText, _unref(searchQuery)]
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-select product-toolbar__control",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(selectedWarehouseId) ? (selectedWarehouseId).value = $event : null)),
                  disabled: _unref(warehouseLockedToProfile)
                }, [
                  _createElementVNode("option", _hoisted_10, _toDisplayString(_unref(t)("product_page.all_warehouses")), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(warehouses), (w) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: w.id,
                      value: w.id
                    }, _toDisplayString(w.name), 9, _hoisted_11))
                  }), 128))
                ], 8, _hoisted_9), [
                  [
                    _vModelSelect,
                    _unref(selectedWarehouseId),
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-select product-toolbar__control",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(selectedCategoryId) ? (selectedCategoryId).value = $event : null))
                }, [
                  _createElementVNode("option", _hoisted_13, _toDisplayString(_unref(t)("product_page.all_categories")), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categories), (c) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: c.id,
                      value: c.id
                    }, _toDisplayString(c.name), 9, _hoisted_14))
                  }), 128))
                ], 512), [
                  [
                    _vModelSelect,
                    _unref(selectedCategoryId),
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-select product-toolbar__control",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(selectedBrandId) ? (selectedBrandId).value = $event : null))
                }, [
                  _createElementVNode("option", _hoisted_16, _toDisplayString(_unref(t)("product_page.all_brands")), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(brands), (b) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: b.id,
                      value: b.id
                    }, _toDisplayString(b.name), 9, _hoisted_17))
                  }), 128))
                ], 512), [
                  [
                    _vModelSelect,
                    _unref(selectedBrandId),
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-select product-toolbar__control",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(selectedUnitId) ? (selectedUnitId).value = $event : null))
                }, [
                  _createElementVNode("option", _hoisted_19, _toDisplayString(_unref(t)("product_page.all_units")), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(units), (u) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: u.id,
                      value: u.id
                    }, _toDisplayString(u.name), 9, _hoisted_20))
                  }), 128))
                ], 512), [
                  [
                    _vModelSelect,
                    _unref(selectedUnitId),
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-select product-toolbar__control",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(selectedSizeId) ? (selectedSizeId).value = $event : null))
                }, [
                  _createElementVNode("option", _hoisted_22, _toDisplayString(_unref(t)("product_page.all_sizes")), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sizes), (s) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: s.id,
                      value: s.id
                    }, _toDisplayString(s.name), 9, _hoisted_23))
                  }), 128))
                ], 512), [
                  [
                    _vModelSelect,
                    _unref(selectedSizeId),
                    void 0,
                    { number: true }
                  ]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("button", {
                class: "btn style-three action-btn d-none",
                disabled: !selectedRowKeys.value.length,
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_unref(exportExcel) && _unref(exportExcel)(...args)))
              }, " Excel ", 8, _hoisted_25),
              _createElementVNode("button", {
                class: "btn style-five action-btn",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_unref(triggerImport) && _unref(triggerImport)(...args)))
              }, _toDisplayString(_unref(t)("product_page.import_button")), 1),
              _createVNode(_component_router_link, {
                to: "/create-product",
                class: "btn style-one action-btn"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("product_page.create_button")) + " ", 1),
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: _unref(t)('product_page.add')
                  }, null, 8, _hoisted_26)
                ]),
                _: 1
              }),
              _createElementVNode("input", {
                ref_key: "importInput",
                ref: importInput,
                type: "file",
                class: "d-none",
                onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_unref(handleImportChange) && _unref(handleImportChange)(...args)))
              }, null, 544)
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_a_table, {
              columns: columns.value,
              "data-source": _unref(filteredProducts),
              "row-key": 'id',
              loading: _unref(loading),
              pagination: _unref(paginationConfig),
              locale: tableLocale.value,
              "row-selection": rowSelection,
              scroll: { x: 1220 },
              onChange: _unref(handleTableChange),
              class: "text-nowrap align-middle product-table"
            }, {
              bodyCell: _withCtx(({ column, record, text }) => [
                (column.key === 'image')
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _unref(getImageUrl)(record),
                      alt: _unref(t)('product_page.product_image'),
                      style: {"width":"40px","height":"30px","object-fit":"contain","background":"#f8f9fa"},
                      class: "rounded-1"
                    }, null, 8, _hoisted_28))
                  : (column.key === 'price')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_unref(stateStore).formatPrice(Number(record.price || 0))), 1)
                      ], 64))
                    : (column.key === 'category')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createTextVNode(_toDisplayString(record.category?.name || _unref(t)("product_page.not_available")), 1)
                        ], 64))
                      : (column.key === 'brand')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            _createTextVNode(_toDisplayString(record.brand?.name || _unref(t)("product_page.not_available")), 1)
                          ], 64))
                        : (column.key === 'unit')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                              _createTextVNode(_toDisplayString(record.unit?.name || _unref(t)("product_page.not_available")), 1)
                            ], 64))
                          : (column.key === 'size')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                _createTextVNode(_toDisplayString(_unref(getSizeLabel)(record)), 1)
                              ], 64))
                            : (column.key === 'type')
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 6,
                                  class: _normalizeClass(record.type === 2 ? 'badge bg-info' : 'badge bg-primary')
                                }, _toDisplayString(record.type === 2 ? _unref(t)("product_page.service") : _unref(t)("product_page.standard")), 3))
                              : (column.key === 'stock')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                    _createTextVNode(_toDisplayString(_unref(getDisplayQty)(record)), 1)
                                  ], 64))
                                : (column.key === 'emenu')
                                  ? (_openBlock(), _createElementBlock("label", {
                                      key: 8,
                                      class: _normalizeClass(["table-emenu-toggle", { 'is-enabled': record.show_on_emenu }])
                                    }, [
                                      _createElementVNode("input", {
                                        type: "checkbox",
                                        checked: Boolean(record.show_on_emenu),
                                        onChange: ($event: any) => (handleEmenuToggle(record, $event))
                                      }, null, 40, _hoisted_29),
                                      _cache[9] || (_cache[9] = _createElementVNode("span", {
                                        class: "table-emenu-toggle__switch",
                                        "aria-hidden": "true"
                                      }, null, -1)),
                                      _createElementVNode("span", _hoisted_30, _toDisplayString(record.show_on_emenu ? _unref(t)("product_page.enabled") : _unref(t)("product_page.disabled")), 1)
                                    ], 2))
                                  : (column.key === 'actions')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                        _createVNode(_component_router_link, {
                                          to: `/product-details?id=${record.id}`,
                                          class: "btn p-0 border-0",
                                          title: _unref(t)('product_page.view')
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("img", {
                                              src: _imports_1,
                                              alt: _unref(t)('product_page.view'),
                                              style: {"width":"14px"}
                                            }, null, 8, _hoisted_32)
                                          ]),
                                          _: 1
                                        }, 8, ["to", "title"]),
                                        _createVNode(_component_router_link, {
                                          to: `/edit-product?id=${record.id}`,
                                          class: "btn p-0 border-0",
                                          title: _unref(t)('product_page.edit')
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("img", {
                                              src: _imports_2,
                                              alt: _unref(t)('product_page.edit'),
                                              style: {"width":"14px"}
                                            }, null, 8, _hoisted_33)
                                          ]),
                                          _: 1
                                        }, 8, ["to", "title"]),
                                        _createElementVNode("button", {
                                          class: "btn p-0 border-0",
                                          title: _unref(t)('product_page.delete'),
                                          onClick: ($event: any) => (_unref(deleteProduct)(record))
                                        }, [
                                          _createElementVNode("img", {
                                            src: _imports_3,
                                            alt: _unref(t)('product_page.delete'),
                                            style: {"width":"14px"}
                                          }, null, 8, _hoisted_35)
                                        ], 8, _hoisted_34)
                                      ]))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 10 }, [
                                        _createTextVNode(_toDisplayString(text), 1)
                                      ], 64))
              ]),
              _: 1
            }, 8, ["columns", "data-source", "loading", "pagination", "locale", "onChange"])
          ])
        ])
      ]),
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      _createVNode(MainFooter)
    ])
  ], 64))
}
}

})